import styled from 'styled-components';

export const RoomInfoMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l35} ${props.theme.spacing.large.l35};
    `
);

export const RoomInfoHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-bottom: ${props.theme.spacing.large.l15};
    `
);

export const RoomInfoHeadText = styled.p(
    props => `
        font-size: ${`${props.fontSize}px` || props.theme.font.large.font16};
        color: ${props.color || props.theme.colors.red.darkd0};
        font-weight: ${props.fontWeight || props.theme.font.fontWeight.bold};
    `
)

export const RoomInfoInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        margin-top: ${props.theme.spacing.base};
        border: 1px solid ${props.theme.colors.grey.lighte7};
        border-radius: ${props.theme.misc.borderRadius.base};
    `
);

export const RoomInnerBlock = styled.div(
    props => `
        width:50%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l15};
        background-color: ${props.theme.colors.grey.lightf9};
        border-radius: ${props.theme.misc.borderRadius.base} 0 0 ${props.theme.misc.borderRadius.base};
        box-shadow: 1px 0 5px -1px rgba(74, 74, 74, 0.15);
        position: relative;
    `
);

export const RoomTypeInfoWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
    `
);

export const RoomInfoWrap = styled.div(
    props => `
        width:78%;
        display: flex;
        flex-direction: column;
    `
);

export const DifferentRoomWrap = styled.div(
    props => `
        display: flex;
        background-color: ${props.theme.colors.white.base};
        padding: ${props.theme.spacing.small.s3} ${props.theme.spacing.large.l13} ${props.theme.spacing.small.s3} ${props.theme.spacing.large.l40};
        position: absolute;
        left:0;
        top:4.5rem;

        &:after{
            content: '';
            position: absolute;
            top:0;
            right:0;
            border-top: 11px solid transparent;
            border-bottom: 10px solid transparent;
            border-right: 10px solid ${props.theme.colors.grey.lightf9};
        }
    `
);

export const DifferentText = styled.p(
    props => `
        font-size: ${props.theme.font.small.font11};
        color: ${props.theme.colors.red.darkd0};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding-left: ${props.theme.spacing.small.s5};
        padding-right: ${props.theme.spacing.small.s5};
    `
);

export const RoomTypeText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

export const GuestBlock = styled.div(
    props => `
        display: flex;
        flex-direction: row;
        font-size: ${props.theme.font.large.font12};
        color: ${props.theme.colors.grey.base};
        padding-top: ${props.theme.spacing.small.s5};
        p {
          padding-left: 1rem;
        }
    `
);

export const RoomImgWrap = styled.div(
    props => `
        width:22%;
        display: flex;
        jusitfy-content: flex-end;
    `
);

export const RoomImg = styled.img(
    props => `
        width:6rem;
        height: 6rem;
    `
);

export const RoomPriceInfoWrap = styled.div(
    props => `
        width:50%;
        display: flex;
        flex-direction: column;
    `
);

export const RoomPriceInnerWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
        padding: ${props.theme.spacing.large.l15};
        &:last-of-type{
            border-bottom: none;
        }
    `
);

export const RoomPriceTextWrap = styled.div(
    props => `
        width: 70%;
        display: flex;
        flex-direction: column;
    `
);

export const RoomPriceSubText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.light9b};
        padding-top: ${props.theme.spacing.small.s2};
    `
);

export const RoomPriceText = styled.p(
    props => `
        font-size: ${`${props.fontSize}px` || props.theme.font.large.font14};
        color: ${props.color || props.theme.colors.grey.base};
        font-weight: ${props.fontWeight || props.theme.font.fontWeight.bold};
    `
);

export const RoomPriceDiffText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};

        span{
            font-size: ${props.theme.font.base};
            color: ${props.theme.colors.grey.base};
        }
    `
);

export const RoomDiffPriceText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.red.darkd0};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const RefundBtnWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-top: ${props.theme.spacing.large.l20};
    `
);

export const RefundBtn = styled.button(
    props => `
        outline: none;
        border: none;
        border-radius: 4rem;
        box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
        background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l30};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-transform: uppercase;
        align-self: flex-end;
        cursor: pointer;
    `
);





